
import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Submit from "./pages/Submit";
import BusinessDetail from "./pages/BusinessDetail";
import Businesses from "./pages/Businesses";
import Events from "./pages/Events";
import About from "./pages/About";
import NotFound from "./pages/NotFound";
import AddEvent from "./pages/AddEvent";
import { SearchProvider } from './context/SearchContext';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

// Create a query client with custom settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000, // 1 minute
      retry: 1,
    },
  },
});

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <SearchProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/submit" element={<Submit />} />
              <Route path="/business/:id" element={<BusinessDetail />} />
              <Route path="/businesses" element={<Businesses />} />
              <Route path="/events" element={<Events />} />
              <Route path="/about" element={<About />} />
              <Route path="/events/add" element={<AddEvent />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </SearchProvider>
      </QueryClientProvider>
      
      {/* Add Sonner toaster for notifications */}
      <Toaster position="top-right" />
    </>
  );
}

export default App;
